import { updateObject } from "utils/helpers/updateObject";
import {
  actionTypes,
  FetchPermissionsFailureAction,
  FetchPermissionsRequestAction,
  FetchPermissionsSuccessAction,
  PermissionAction,
  ResetPermission,
  SetPermissionFailureAction,
  SetPermissionRequestAction,
  SetPermissionSuccessAction,
  stateStatusType,
} from "./actionType";
import { initialState, PermissionState } from "./state";

// fetch permission
const fetchPermissionsRequest = (
  state: PermissionState,
  action: FetchPermissionsRequestAction
) => {
  return updateObject(state, {
    fetchPermissionState: {
      ...state.fetchPermissionState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const fetchPermissionsSuccess = (
  state: PermissionState,
  action: FetchPermissionsSuccessAction
) => {
  return updateObject(state, {
    fetchPermissionState: {
      ...state.fetchPermissionState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      permission: action.payload,
    },
  });
};

const fetchPermissionsFail = (
  state: PermissionState,
  action: FetchPermissionsFailureAction
) => {
  return updateObject(state, {
    fetchPermissionState: {
      ...state.fetchPermissionState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      permission: null,
    },
  });
};

//set permission
const setPermissionRequest = (
  state: PermissionState,
  action: SetPermissionRequestAction
) => {
  return updateObject(state, {
    genericPermissionState: {
      ...state.genericPermissionState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const setPermissionSuccess = (
  state: PermissionState,
  action: SetPermissionSuccessAction
) => {
  const newRole = state.fetchPermissionState.permission ?? [];
  return updateObject(state, {
    genericPermissionState: {
      ...state.genericPermissionState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    fetchPermissionState: {
      ...state.fetchPermissionState,
      permission: [...newRole, action.payload],
    },
  });
};

const setPermissionFail = (
  state: PermissionState,
  action: SetPermissionFailureAction
) => {
  return updateObject(state, {
    genericPermissionState: {
      ...state.genericPermissionState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    fetchPermissionState: {
      ...state.fetchPermissionState,
      isLoading: false,
    },
  });
};
const resetPermission = (state: PermissionState, action: ResetPermission) => ({
  ...state,
  genericPermissionState: { ...initialState.genericPermissionState },
});

const fetchPermission = (state = initialState, action: PermissionAction) => {
  switch (action.type) {
    case actionTypes.FETCH_PERMISSION_REQUEST:
      return fetchPermissionsRequest(state, action);
    case actionTypes.FETCH_PERMISSION_SUCCESS:
      return fetchPermissionsSuccess(state, action);
    case actionTypes.FETCH_PERMISSION_FAIL:
      return fetchPermissionsFail(state, action);
    case actionTypes.SET_PERMISSION_REQUEST:
      return setPermissionRequest(state, action);
    case actionTypes.SET_PERMISSION_SUCCESS:
      return setPermissionSuccess(state, action);
    case actionTypes.SET_PERMISSION_FAIL:
      return setPermissionFail(state, action);
    case actionTypes.RESET_PERMISSION:
      return resetPermission(state, action);
    default:
      return state;
  }
};

export default fetchPermission;
